export default __webpack_public_path__ + "static/media/10.62b81d1b.jpg";